import { render, staticRenderFns } from "./Pause2Icon.vue?vue&type=template&id=7ab7f98c&"
import script from "./Pause2Icon.vue?vue&type=script&lang=js&"
export * from "./Pause2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports